<template>
  <el-tabs v-model="activeName"    @tab-click="handleClick">
    <el-tab-pane label="待办工作" name="first">
        <formMyTask v-if="activeName==='first'" :options="options"/>
    </el-tab-pane>
    <el-tab-pane label="办结工作" name="second">
        <formMyApprovedTask v-if="activeName==='second'" :options="options" />
    </el-tab-pane>
    <el-tab-pane label="由我创建" name="third">
        <formMyHistoryTask v-if="activeName==='third'" :doType="2" :options="options"/>
    </el-tab-pane>
    <el-tab-pane label="全部工作" name="four">
        <formMyHistoryTask v-if="activeName==='four'" :options="options"/>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import formMyTask from './formMyTask';
import formMyApprovedTask from './formMyApprovedTask';
import formMyHistoryTask from './formMyHistoryTask';
import { FlowEntryController } from '@/api/flowController.js';
export default {
  components: {
    formMyTask,
    formMyApprovedTask,
    formMyHistoryTask
  },
  data () {
    return {
      activeName: '',
      options: []
    };
  },
  created(){
    this.init()
    this.getSelect()
  },
  methods: {
    init(){
       const name = localStorage.getItem('tabName')
       this.activeName =  name || 'first' 
    },
    getSelect() {
      FlowEntryController.getTreeList(this, {}).then(res => {
        let list = []
        for (let key in res.data) {
          let obj = {
            processDefinitionName: key,
            processDefinitionKey: res.data[key].processDefinitionKey,
            children: res.data[key]
          }
          list.push(obj)
        }
        this.options = list
      })
    },
    handleClick (tab, event) {
      localStorage.removeItem('search')
      localStorage.removeItem('page')
      localStorage.setItem('tabName',this.activeName)
    }
  }
};
</script>
